import { Injectable, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { PlatformService } from '../platform/platform.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationHistoryService implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private readonly stack: string[] = [];

  constructor(
    private readonly router: Router,
    private readonly platformService: PlatformService
  ) {
    if (!this.platformService.isBrowser()) {
      return;
    }

    this.stack.push(this.normalizeUrl(this.router.url));

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event) => {
        const url = this.normalizeUrl(event.urlAfterRedirects);
        if (this.stack[this.stack.length - 1] !== url) {
          this.stack.push(url);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  hasPreviousEntry(): boolean {
    return this.stack.length > 1;
  }

  backOrFallback(location: Location, fallbackUrl: string): void {
    if (this.hasPreviousEntry()) {
      location.back();
      return;
    }

    this.router.navigateByUrl(fallbackUrl);
  }

  private normalizeUrl(url: string): string {
    return url.split('#')[0].split('?')[0] || '/';
  }
}
